import mixins from 'synergycms_core/src/less/mixins';

export default {
    deepLinkContainer: {},
    deepLinkBanner: {},
    deepLinkImgText: {},
    deepLinkBox1: {},
    deepLinkBox2: {},
    deepLinkTitle: {},
    deepLinkTitleTxt: {},
    deepLinkImages: {},
    deepLinkBtn: {},
    deepLinkBtnHref: {},
    styleForModal: {},
    modalContent: {
        font: '16px Roboto, sans-serif',
        color: 'rgb(140, 140, 140)',
        maxWidth: '870px',
        margin: '0 auto',
    },
    closeButton: {
        width: '24px',
        height: '24px',
        top: '15px',
        right: '15px',
        position: 'absolute',
        zIndex: '600',
        background: 'none',
        cursor: 'pointer',
        color: data => data.mainColor,
        border: '0',
        fontSize: '16px',
        fontWeight: '600',
        '&:lang(ar)': {
            left: '15px',
            right: 'auto',
            float: 'left'
        },
        '& > span': {
            position: 'relative',
            bottom: '1px',
        },
        '@media (min-width: 901px)': {
            fontSize: '21px'
        },
    },
    defaultStyle: {
        '&$deepLinkContainer': {
            position: 'relative',
            background: '#f1f1f1',
            paddingBottom: '20px',
            '@media (min-width: 801px), print': {
                padding: '0 20px 20px'
            },
            '& $deepLinkBanner': {
                backgroundColor: '#fff',
                ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
                ...mixins.boxSizing('content-box'),
                border: 0,
                color: 'inherit',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '36px 10px',
                gap: '28px',
                '@media (min-width: 601px)': {
                    padding: '88px 20px',
                },
                '@media (min-width: 801px), print': {
                    maxWidth: '1000px',
                    margin: '0 auto',
                    padding: '88px 0',
                },
                '& $deepLinkBox1': {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: '24px',
                    width: '100%',
                    '@media (min-width: 801px)': {
                        width: 'unset',
                    },
                    '& $deepLinkTitle': {
                        font: 'bold 18px Roboto, sans-serif',
                        textAlign: 'center',
                        letterSpacing: '0.6px',
                        padding: '0 20px',
                        '@media (min-width: 801px)': {
                            padding: 'unset',
                            fontSize: '20px'
                        },
                    },
                    '& $deepLinkImages': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        '& img': {
                            width: '32%',
                        }
                    }
                },
                '& $deepLinkBox2': {
                    display: 'flex',
                    '& $deepLinkBtn': {
                        '& $deepLinkBtnHref': {
                            color: '#fff',
                            font: "600 14px Roboto,sans-serif",
                            width: '100%',
                            border: data => '1px solid ' + data.mainColor,
                            backgroundColor: data => data.mainColor,
                            padding: '0 20px',
                            textAlign: 'center',
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxSizing: 'border-box',
                            minHeight: '44px',
                            minWidth: '178px',
                            '&:hover': {
                                WebkitTransition: '0.3s',
                                OTransition: '0.3s',
                                MsTransition: '0.3s',
                                MozTransition: '0.3s',
                                color: data => data.mainColor,
                                backgroundColor: 'transparent'
                            },
                            '@media (min-width: 801px)': {
                                fontSize: '15px',
                            },
                        }
                    }
                }
            },
        },
        '&$styleForModal': {
            '&$deepLinkContainer': {
                boxSizing: 'border-box',
                width: '100%',
                maxHeight: '316px',
                height: '100%',
                boxShadow: '6px 6px 4px 2px #00000040',
                padding: '0',
                background: '#fff',
                '& $deepLinkBanner': {
                    padding: '36px 10px',
                    maxWidth: 'unset',
                    margin: 'unset',
                    maxHeight: '316px',
                    height: '100%',
                    boxSizing: 'border-box',
                    boxShadow: 'unset',
                },
            }
        }
    },
    mBoxModalStyle:{
        padding: '0 12px',
        '@media (min-width: 901px)': {
                padding: 'unset'
            },
    }
};